export enum HeaderType {
  Sticky = 'sticky',
  Static = 'static',
}
